import { PageName } from 'generated/types'
import { FlowRoute } from 'utils/FlowProvider/types'

export const PageToRoute = {
  [PageName.AboutPortfolio]: FlowRoute.AboutPortfolio,
  [PageName.Analyzing]: FlowRoute.Analyzing,
  [PageName.BankLinkSuccess]: FlowRoute.BankLinkSuccess,
  [PageName.ChooseFundingSource]: FlowRoute.ChooseFundingSource,
  [PageName.CardOrderReview]: FlowRoute.CardOrderReview,
  [PageName.CardSignature]: FlowRoute.SignYourCard,
  [PageName.ContactInfo]: FlowRoute.ContactInfo,
  [PageName.CryptoLander]: FlowRoute.CryptoLander,
  [PageName.DirectBankIntegration]: FlowRoute.DirectBankIntegration,
  [PageName.DirectBankIntegrationRedirect]: FlowRoute.DirectBankIntegrationRedirect,
  [PageName.DirectToMobile]: FlowRoute.DirectToMobileLander,
  [PageName.EsgDetails]: FlowRoute.AboutESG,
  [PageName.EsgEducation]: FlowRoute.ESGEducationFlow,
  [PageName.Funding]: FlowRoute.Funding,
  [PageName.Institutions]: FlowRoute.Institutions,
  [PageName.InvestInterstitial]: FlowRoute.InvestInterstitial,
  [PageName.InvestorQuestions]: FlowRoute.InvestorQuestions,
  [PageName.ManualFundingSource]: FlowRoute.ManualFundingSource,
  [PageName.MfaSetUp]: FlowRoute.MFASetup,
  [PageName.MocReferralReminder]: FlowRoute.MOCReferralReminder,
  [PageName.MocRoutingInterstitial]: FlowRoute.MOCInterstitial,
  [PageName.MocSuccess]: FlowRoute.MOCSuccess,
  [PageName.Occupation]: FlowRoute.Occupation,
  [PageName.OneTimeDeposit]: FlowRoute.OneTimeDeposit,
  [PageName.OneTimeInvestment]: FlowRoute.OneTimeInvestment,
  [PageName.PersonalInfo]: FlowRoute.PersonalInfo,
  [PageName.PlaidLinkRedirect]: FlowRoute.PlaidLinkRedirect,
  [PageName.PreviewPortfolio]: FlowRoute.PreviewPortfolio,
  [PageName.PricingInterstitial]: FlowRoute.PricingInterstitial,
  [PageName.ProgressScreen_1]: FlowRoute.MOCProgressStepOne,
  [PageName.ProgressScreen_2]: FlowRoute.MOCProgressStepTwo,
  [PageName.ProgressScreen_3]: FlowRoute.MOCProgressStepThree,
  [PageName.PortfolioDetails]: FlowRoute.PortfolioOverview,
  [PageName.RecurringDeposit]: FlowRoute.RecurringDeposit,
  [PageName.RecurringInvestment]: FlowRoute.RecurringInvestment,
  [PageName.ReferralDisclosure]: FlowRoute.ReferralDisclosure,
  [PageName.ReferralReward]: FlowRoute.ReferralReward,
  [PageName.RoundUpsFunding]: FlowRoute.RoundUpsFunding,
  [PageName.RoundUpsInterstitial]: FlowRoute.RoundUpsInterstitial,
  [PageName.RoundUpsPast]: FlowRoute.RoundUpsPast,
  [PageName.RoundUpsSetUp]: FlowRoute.RoundUpsSetup,
  [PageName.SelectPortfolioTheme]: FlowRoute.SelectPortfolioTheme,
  [PageName.SecondChanceBankLink]: FlowRoute.SecondChanceBankLink,
  [PageName.SecondChanceInstitutions]: FlowRoute.Institutions,
  [PageName.ShippingAddress]: FlowRoute.ShippingAddress,
  [PageName.Signup]: FlowRoute.Signup,
  [PageName.Ssn]: FlowRoute.SSN,
  [PageName.Success]: FlowRoute.Success,
  [PageName.SuitabilityQuestions]: FlowRoute.SuitabilityQuestions,
}
